import EvComponent from "@transformd-ltd/electronic-verification";
import Formatic, { Data, Overrides } from "@transformd-ltd/sdk";
import React from "react";
import ReactDOM from "react-dom";
import {
  AboutYouCards,
  LogoContainer,
  NeoEmitter,
  ProductCards,
  ProgressBar,
  SummaryTable,
  TermsModal
} from "../../../../customComponent/NeoOnboarding";
import AplyIdProcessing from "../../../../customComponent/NeoOnboarding/AplyIdProcessing";
import { ParamsFromURL } from "../../../../javascript/common";
import "../../styles/index.scss";

const params = ParamsFromURL();
let data;

export function createForm(
  formContainer,
  formApiKey,
  formId,
  formBranch,
  formChannel,
  formConfig,
  initialValues = {}
) {
  data = new Data();

  const Form = () => {
    return (
      <Formatic
        data={data}
        formId={formId}
        apiKey={formApiKey}
        environment={formBranch}
        config={formConfig}
        channel={formChannel}
        submissionId={params.submissionID}
        serverUrl="https://api.transformd.com/graphql"
        apiServerUrl="https://api.transformd.com"
        subscriptionServerUrl="wss://api.transformd.com/subscriptions"
        initialValues={initialValues}
        theme="transformd"
        runReduxDevTools={process.env.NODE_ENV === "development"}
      >
        <Overrides.OverrideFieldContainer
          component={EvComponent}
          type="electronicVerification"
        />
        <Overrides.OverrideFieldContainer
          component={ProgressBar}
          type="customProgressBar"
          getData={getDataHelper}
        />
        <Overrides.OverrideFieldContainer
          component={LogoContainer}
          type="customLogoContainer"
          getData={getDataHelper}
        />
        <Overrides.OverrideFieldContainer
          component={ProductCards}
          type="customProductCards"
          getData={getDataHelper}
        />
        <Overrides.OverrideFieldContainer
          component={TermsModal}
          type="customTermsModal"
          getData={getDataHelper}
        />
        <Overrides.OverrideFieldContainer
          component={AboutYouCards}
          type="customAboutYouCards"
          getData={getDataHelper}
        />
        <Overrides.OverrideFieldContainer
          component={SummaryTable}
          type="customSummaryTable"
          getData={getDataHelper}
        />
        <Overrides.OverrideFieldContainer
          component={AplyIdProcessing}
          type="customAplyIdProcessing"
          getData={getDataHelper}
        />
        <Overrides.OverrideFieldContainer
          component={NeoEmitter}
          type="customEmitterHandler"
          getData={getDataHelper}
        />
      </Formatic>
    );
  };

  ReactDOM.render(<Form />, document.getElementById(formContainer));

  createMutationObserver(formContainer);
  createResizeMutationObserver(formContainer);
  setupVOIObserver();
}

function createMutationObserver(formContainer) {
  // Select the node that will be observed for mutations
  const targetNode = document.getElementById(formContainer);

  // Options for the observer (which mutations to observe)
  const config = { attributes: true, childList: true, subtree: true };

  // Callback function to execute when mutations are observed
  const callback = (mutationList, observer) => {
    handleCheckTermsModalScroll();
  };

  // Create an observer instance linked to the callback function
  const observer = new MutationObserver(callback);

  // Start observing the target node for configured mutations
  observer.observe(targetNode, config);
}

const createResizeMutationObserver = () => {
  // identify an element to observe
  const elementToObserve = document.querySelector("#transformd > div.formatic");

  // create a new instance of `MutationObserver` named `observer`,
  // passing it a callback function
  const observer = new MutationObserver(() => {
    const parent = document.querySelector("div#transformd");
    const child = document.querySelector("div#transformd > div.formatic");

    try {
      var childScaleX = child.getBoundingClientRect().width / child.offsetWidth;
      var childTrueHeight = child.getBoundingClientRect().height;
      parent.style.height = `${childTrueHeight + 40}px`;
    } catch (err) {}
  });

  // call `observe()` on that MutationObserver instance,
  // passing it the element to observe, and the options object
  observer.observe(elementToObserve, {
    subtree: true,
    childList: true,
    attributes: true,
  });

  window.addEventListener("resize", (event) => {
    const parent = document.querySelector("div#transformd");
    const child = document.querySelector("div#transformd > div.formatic");

    try {
      var childScaleX = child.getBoundingClientRect().width / child.offsetWidth;
      var childTrueHeight = child.getBoundingClientRect().height;
      parent.style.height = `${childTrueHeight + 40}px`;
    } catch (err) {}
  });
};

/** After mutation observer trigger - check if user has fully scrolled TermsModal */
function handleCheckTermsModalScroll() {
  const nextPageBtn =
    document.querySelector(".formatic-button.formatic-action-bar-root__next") ||
    document.querySelector(".formatic-button.formatic-action-bar-root__submit");

  if (!nextPageBtn) return; // Empty element

  const currentPageID = getDataHelper().getCurrentPageID();

  const nameOfClass = "confirmation-page-next-btn--disabled";
  const termsAndConditionsModalId = "64c9aae8b9cd4359eb0f39e3";
  const termsAndConditionsPageId = "62870de18f813600142a64b9";

  if (
    currentPageID === termsAndConditionsPageId &&
    !getDataHelper().getFieldValue(termsAndConditionsModalId)
  ) {
    // On confirmation page - manage disabling of button
    // Avoid infinite loop from mutation observer, only execute if not already exists
    if (!nextPageBtn.classList.contains(nameOfClass))
      nextPageBtn.classList.add(nameOfClass);
  } else if (!!currentPageID) {
    // On any other page - clean up anything
    // Avoid infinite loop from mutation observer, only execute if not already exists
    if (nextPageBtn.classList.contains(nameOfClass))
      nextPageBtn.classList.remove(nameOfClass);
  } else {
  }
}

export function getDataHelper() {
  return data;
}

/** Used to watch for VOI pass, and navigate to product page when it has passed */
function setupVOIObserver() {
  var FormaticDataHelper = getDataHelper();
  var FormaticEmitter = FormaticDataHelper.getEmitter();
  console.log("VOI Observer Init");

  let verificationPassedTimeout = null;

  FormaticEmitter.on("PageRender", function (event) {
    console.info("PageRender");
    clearTimeout(verificationPassedTimeout);
    scrollTo({ top: 0 });

    // CURRENT PAGE IS THE VERIFICATION WAITING SCREEN PAGE
    if (event.id === "62870ced0fdd5f00130c647c") {
      console.log("Awaiting VOI");
      verificationPassedTimeout = setTimeout(navigateToProductPage, 300);
    }
  });
  function navigateToProductPage() {
    const DataHelper = window.Formatic.getDataHelper();
    const verificationPassed = DataHelper.getFieldValue(
      "632d126b7915ab00733e86e2"
    );

    console.log("checking: ", verificationPassed);

    if (verificationPassed === "YES") {
      console.log(
        "verification has passed successfully, redirecting to next page"
      );
      clearTimeout(verificationPassedTimeout);
      DataHelper.navigateToPage("62870dfd0fdd5f0012534ef1");
    } else {
      verificationPassedTimeout = setTimeout(navigateToProductPage, 300);
    }
  }
}
